export default __webpack_public_path__ + "static/media/army_43.6a8ace9b.jpg";